<template>
    <div class="page" :style="{'--styleColor': actInfo.color, backgroundImage:'url('+ actInfo.bg_other +')'}">
        <PageLoading v-if="loading"></PageLoading>
        <TipsWechat ref="child" v-if="platform==2"></TipsWechat>
        <TipsZonglan ref="child" v-if="platform==3"></TipsZonglan>
        <TipsHbrb ref="child" v-if="platform==4"></TipsHbrb>
        <div class="mainBox">
          <div class="avatar"><img src="@/assets/images/learn/avatar.png" alt=""></div>

          <div class="username">{{userData.nickname || userData.username || userData.person_name}}</div>
          <div class="boxline"></div>
          <div class="userData">
            <!-- <div class="total">
              <span class="txt">总{{actInfo.score_txt || '学时'}}</span>
              <span class="num">{{userData.total_score || 0}}</span>
            </div>
            <div class="line"></div> -->
            <div class="must" v-if="actInfo.pass_score>0">
              <span class="txt">必修{{actInfo.score_txt || '学时'}}</span>
              <span class="num">{{actInfo.pass_score}}</span>
            </div>
            <div class="line" v-if="actInfo.pass_score>0"></div>
            <div class="done">
              <span class="txt">我的{{actInfo.score_txt || '学时'}}</span>
              <span class="num">{{userData.score_learn || 0}}</span>
            </div>
          </div>
          <div class="boxline"></div>
          <div class="optBox">
            <div class="icoBox" @click="noticeBox">
                 <div class="icon icon1">
                    <i class="huodong icon-tishi"></i>                    
                 </div>
                 <span>活动说明</span>
            </div>

            <div class="icoBox" @click="editBox" v-if="actInfo.isreg>0">
                 <div class="icon icon2">
                    <i class="huodong icon-bianji2"></i>                    
                 </div>
                 <span>资料修改</span>
            </div>

            <!-- <div class="icoBox" @click="kefuBox">
                 <div class="icon icon3">
                    <i class="huodong icon-kefu"></i>                    
                 </div>
                 <span>联系客服</span>
            </div> -->

            <div class="icoBox" @click="zhengshuBox" v-show="actInfo.pass_score>0">
                 <div class="icon icon4">
                    <i class="huodong icon-jihuashu"></i>                    
                 </div>
                 <span>我的证书</span>
            </div>

            <div class="icoBox" @click="logOut">
                 <div class="icon icon5">
                    <i class="huodong icon-qidong"></i>                     
                 </div>
                 <span>退出登录</span>
            </div>

          </div>
        </div>

        <van-popup v-model="showZhengshu" class="showBox" closeable close-icon="close">
          <div class="zhengshu">
            <div id="posterMiddle" class="zsBox">
              <div class="zsTxt">{{username}}</div>
              <img src="@/assets/images/learn/zhengshu.png" class="zsBg"/>
            </div>
            <div class="loadBox" v-show="showLoad">
              <van-loading vertical>加载中...</van-loading>
            </div>
            <div class="downBox">
              <div id="Image" class="imgBox"></div>
              <div class="downTxt"><i class="huodong icon-cQuery"></i> 长按图片下载</div>
            </div>
          </div>
        </van-popup>

        

        <!-- 活动规则 -->
        <van-popup v-model="showNotice" closeable close-icon="close" position="bottom" round>          
          <div class="noticBox">        
            <h2 class="noticTitle">
              <span class="line"></span>
              <span class="text">活动说明</span>
              <span class="line"></span>
            </h2>
            <div class="noticTxt" v-html="actExtend.explain"></div>
          </div>
        </van-popup>

        <!-- 联系客服 -->
        <van-popup v-model="showKefu" closeable close-icon="close" position="bottom" round>          
          <div class="noticBox">        
            <h2 class="noticTitle">
              <span class="line"></span>
              <span class="text">联系客服</span>
              <span class="line"></span>
            </h2>
            <div class="noticTxt" v-html="kefu">
              <!-- <p>学习听课及答题考试期间，如有疑问，可联系纵览新闻（河北新闻网）工作人员，也可在“2023重点行业工伤预防宣传企业群”内提问留言，我们会第一时间回复解决。</p> -->
            </div> 
          </div>
        </van-popup>

        <!-- 修改信息 -->
        <van-popup v-model="showEdit" closeable close-icon="close" position="bottom" round>          
          <div class="noticBox">        
            <h2 class="noticTitle">
              <span class="line"></span>
              <span class="text">修改资料</span>
              <span class="line"></span>
            </h2>
            <div class="editBox">
              <van-cell-group>
                <van-form @submit="onSubmit">
                  <!-- 固定登记项：仅当未配置自定义表单时展示 -->
                  <template v-if="formFields.length === 0">
                  <van-field v-model="person_name" name="person_name" label="" placeholder="请输入姓名" :rules="[{ required: true, message: '' }]" v-if="actInfo.dis_reg && (actInfo.dis_reg.includes('xm'))">
                    <van-icon class="huodong" class-prefix="icon" slot="left-icon" name="renwu-ren" size="20"></van-icon>
                  </van-field>

                  <van-field v-model="idcard" name="idcard" type="text" label="" placeholder="请输入身份证号" :rules="[{ required: true, message: '' }]" v-if="actInfo.dis_reg && (actInfo.dis_reg.includes('sfzh'))">
                    <van-icon class="huodong" class-prefix="icon" slot="left-icon" name="zhengjian" size="20"></van-icon>
                  </van-field>

                  <van-field v-model="contact" name="contact" type="text" label="" placeholder="请输入手机号" :rules="[{ required: true, message: '' }]" v-if="actInfo.dis_reg && (actInfo.dis_reg.includes('dh'))">
                    <van-icon class="huodong" class-prefix="icon" slot="left-icon" name="zhengjian" size="20"></van-icon>
                  </van-field>

                  <van-field v-model="area_name" name="area_name" is-link readonly placeholder="请选择所在地区" @click="showSelect = true" :rules="[{ required: true, message: '' }]" v-if="actInfo.dis_reg && (actInfo.dis_reg.includes('dq'))">
                    <van-icon class="huodong" class-prefix="icon" slot="left-icon" name="gongsiqiye1" size="20"></van-icon>
                  </van-field>

                  <van-popup v-model="showSelect" round position="bottom" v-if="actInfo.dis_reg && (actInfo.dis_reg.includes('dq'))"> 
                    <van-cascader
                      v-model="areaid"
                      title="请选择所属组织"
                      :options="options"
                      :field-names="fieldNames"
                      @close="showSelect = false"
                      @finish="onFinish"
                    />
                  </van-popup>

                  <van-field v-model="areaid" name="areaid" type="hidden"  style="display:none;" v-if="actInfo.dis_reg && (actInfo.dis_reg.includes('dq'))">
                  </van-field>

                  <van-field v-model="address" name="address" label="" placeholder="请输入详细地址" :rules="[{ required: true, message: '' }]" v-if="actInfo.dis_reg && (actInfo.dis_reg.includes('dz'))">
                    <van-icon class="huodong" class-prefix="icon" slot="left-icon" name="dingwei1" size="20"></van-icon>
                  </van-field>
                  
                  <van-field v-model="company" name="company" label="" placeholder="请输入所在单位" :rules="[{ required: true, message: '' }]" v-if="actInfo.dis_reg && (actInfo.dis_reg.includes('dw'))">
                    <van-icon class="huodong" class-prefix="icon" slot="left-icon" name="zixun" size="20"></van-icon>
                  </van-field>
                  </template>

                  <!-- 自定义登记表单（新活动） -->
                  <template v-if="formFields.length > 0">
                    <template v-for="(f, fi) in formFields">

                      <!-- 文本框 -->
                      <van-field
                        v-if="f.type === 'text'"
                        v-model="formData[f.model]"
                        :name="f.model"
                        :label="f.icon ? '' : f.label"
                        :placeholder="f.placeholder || ('请输入' + f.label)"
                        :maxlength="f.max_length > 0 ? f.max_length : undefined"
                        :rules="f.required ? [{ required: true, message: '' }] : []"
                      >
                        <van-icon v-if="f.icon" class="huodong" class-prefix="icon" slot="left-icon" :name="f.icon" size="20"></van-icon>
                      </van-field>

                      <!-- 单选 -->
                      <template v-if="f.type === 'radio'">
                        <!-- 单选按钮 -->
                        <van-field
                          v-if="f.display_type !== 'select' && f.display_type !== 'index'"
                          :name="f.model"
                          :label="f.icon ? '' : f.label"
                          :rules="f.required ? [{ required: true, message: '' }] : []"
                        >
                          <van-icon v-if="f.icon" class="huodong" class-prefix="icon" slot="left-icon" :name="f.icon" size="20"></van-icon>
                          <template #input>
                            <van-radio-group v-model="formData[f.model]" direction="horizontal" icon-size="16">
                              <van-radio v-for="opt in f.options" :key="opt.value" :name="opt.value">{{ opt.label }}</van-radio>
                            </van-radio-group>
                          </template>
                        </van-field>

                        <!-- 下拉框 -->
                        <template v-else-if="f.display_type === 'select'">
                          <van-field
                            v-model="radioText[f.model]"
                            :name="f.model"
                            :label="f.icon ? '' : f.label"
                            is-link
                            readonly
                            :placeholder="f.placeholder || ('请选择' + f.label)"
                            :rules="f.required ? [{ required: true, message: '' }] : []"
                            @click="radioShow[f.model] = true"
                          >
                            <van-icon v-if="f.icon" class="huodong" class-prefix="icon" slot="left-icon" :name="f.icon" size="20"></van-icon>
                          </van-field>
                          <van-popup v-model="radioShow[f.model]" round position="bottom">
                            <van-picker
                              v-if="radioShow[f.model]"
                              show-toolbar
                              :columns="f.options"
                              value-key="label"
                              :default-index="optionIndex(f)"
                              :title="'请选择' + f.label"
                              @confirm="(val, idx) => onRadioConfirm(f, idx)"
                              @cancel="radioShow[f.model] = false"
                            />
                          </van-popup>
                        </template>

                        <!-- 首字母索引 -->
                        <template v-else>
                          <van-field
                            v-model="radioText[f.model]"
                            :name="f.model"
                            :label="f.icon ? '' : f.label"
                            is-link
                            readonly
                            :placeholder="f.placeholder || ('请选择' + f.label)"
                            :rules="f.required ? [{ required: true, message: '' }] : []"
                            @click="radioShow[f.model] = true"
                          >
                            <van-icon v-if="f.icon" class="huodong" class-prefix="icon" slot="left-icon" :name="f.icon" size="20"></van-icon>
                          </van-field>
                          <van-popup v-model="radioShow[f.model]" closeable round position="bottom" :style="{ height: '80%' }" class="areaBox">
                            <van-index-bar highlight-color="#1989fa" :index-list="radioIndexData(f).indexList">
                              <div v-for="grp in radioIndexData(f).filterData" :key="grp.letter">
                                <van-index-anchor :index="grp.letter"></van-index-anchor>
                                <van-cell v-for="opt in grp.list" :key="opt.value" :title="opt.label" @click="onRadioIndexSelect(f, opt)" />
                              </div>
                            </van-index-bar>
                          </van-popup>
                        </template>
                      </template>

                      <!-- 多选 -->
                      <van-field
                        v-if="f.type === 'checkbox'"
                        :name="f.model"
                        :label="f.icon ? '' : f.label"
                        :rules="f.required ? [{ required: true, message: '' }] : []"
                      >
                        <van-icon v-if="f.icon" class="huodong" class-prefix="icon" slot="left-icon" :name="f.icon" size="20"></van-icon>
                        <template #input>
                          <van-checkbox-group v-model="formData[f.model]" direction="horizontal">
                            <van-checkbox v-for="opt in f.options" :key="opt.value" :name="opt.value">{{ opt.label }}</van-checkbox>
                          </van-checkbox-group>
                        </template>
                      </van-field>

                      <!-- 地区联动 -->
                      <template v-if="f.type === 'region'">
                        <van-field
                          v-model="regionText[f.model]"
                          :name="f.model"
                          :label="f.icon ? '' : f.label"
                          is-link
                          readonly
                          :placeholder="f.placeholder || ('请选择' + f.label)"
                          :rules="f.required ? [{ required: true, message: '' }] : []"
                          @click="regionShow[f.model] = true"
                        >
                          <van-icon v-if="f.icon" class="huodong" class-prefix="icon" slot="left-icon" :name="f.icon" size="20"></van-icon>
                        </van-field>
                        <van-popup v-model="regionShow[f.model]" round position="bottom">
                          <van-cascader
                            v-model="formData[f.model]"
                            :title="'请选择' + f.label"
                            :options="regionOptions[f.model] || []"
                            @close="regionShow[f.model] = false"
                            @finish="onRegionFinish(f, $event)"
                          />
                        </van-popup>
                      </template>

                    </template>
                  </template>

                  <div class="subBtn">
                    <van-button round block type="info" native-type="submit">保存信息</van-button>
                  </div>

                </van-form>
              </van-cell-group>
            </div> 
          </div>
        </van-popup>

        <van-popup v-model="showSelect" closeable position="bottom" :style="{ height: '90%' }" class="areaBox">
          <van-index-bar  highlight-color="#1989fa" :index-list="indexList">
            <div v-for="item in filterData" :key="item.letter">
              <van-index-anchor :index="item.letter"></van-index-anchor>
              <van-cell v-for="(row,index) in item.list" :key="index" :title="row.text" @click="setAreaid(row)"/>
            </div>
          </van-index-bar>
        </van-popup>

        
        

        <NavBox :actInfo="actInfo" homePath="/list"></NavBox>
      
        <LotteryBox v-if="actInfo.dis_btn && (actInfo.dis_btn.includes('cj'))" :lotteryid="Number(actInfo.bind_lotteryid)"></LotteryBox>
        <stat :actId="Number(learnid)" :actTitle="actInfo.title" :platform="Number(platform)" v-if="learnid"></stat>
    </div>


    
</template>

<script>

import {reqUserInfo, reqUserEdit, reqLearnExtend, reqLearnInfo, reqRegion} from '@/api/learn' //动态接口
import {reqArea} from '@/api/index2.js' //静态接口
//纵览顶部提示栏及唤起app组件
import PageLoading from '@/components/PageLoading.vue'
import LotteryBox from '@/components/LotteryBox.vue'
import stat from '@/components/stat.vue'
import NavBox from '@/components/NavBox.vue'
import TipsWechat from '@/components/TipsWechat.vue'
import TipsZonglan from '@/components/TipsZonglan.vue'
import TipsHbrb from '@/components/TipsHbrb.vue'
import zonglan from '@/utils/cp-zonglan.js'

//分享
import { wxShare } from '@/utils/wxshare-wes2.com.js'

import Cookies from 'js-cookie'

//生成证书
import html2canvas from 'html2canvas';
import Canvas2Image from '@/utils/Canvas2Image.js'

export default {
  name: 'myCenter',
  mixins: [],
  components: { PageLoading, TipsWechat, TipsZonglan, TipsHbrb, LotteryBox, NavBox, stat },
  props: {},
  data () {
    return {
      platform:0, //来源平台：1电脑端，2微信端，3纵览客户端，4河北日报客户端，5H5端
      loading:false,
      learnid:0,
      token:"",
      accountId:'',
      uniqueId:'',
      accessid:'',
      openid:'',
      actInfo:"",
      actExtend:{},
      nickname:"",
      username:"",
      scoreAll:0,
      scoreMust:0,
      scoreComplete:0,
      getCert:false,
      showNotice:false,
      showKefu:false,
      showEdit:false,
      showZhengshu:false,
      showLoad:true, //证书加载状态
      userData:{},

      person_name:'',      
      contact:'',     
      idcard:'',
      address:'',
      company:'',
      passCode:'',
      showSelect: false,
      areaid: '',
      area_name: '',
      fieldNames: {
        text: 'region_name',
        value: 'region_id',
        children: 'children',
      },
      // 选项列表，children 代表子选项，支持多级嵌套
      options: [
        {
          text: '省政府有关部门',
          value: '1',
          children: [
            { 
              text: '河北省发展和改革委员会', 
              value: '3',
              children:[
                { text:'石家庄',value:'8'}
              ]
            },
            { text: '河北省人力资源和社会保障厅', value: '4' },
            { text: '河北省水利厅', value: '5' }
          ],
        },
        {
          text: '江苏省',
          value: '2',
          children: [{ text: '南京市', value: '6' }],
        },
      ],
      indexList: [],
      filterData:[], // 处理后的 待渲染数据      
      areaList:[],
      shareImg:"https://img2.hebnews.cn/img/home.53fe0d7.png",
      shareTitle:"",
      shareDesc:"", 
      style:{},
      explain:"",
      kefu:"",
      // 自定义登记表单（新活动）
      formFields: [],       // 字段定义（来自 info 接口）
      formData: {},         // 表单值 {field_name: value}
      regionText: {},       // 地区字段显示文本 {field_name: 'xx/xx'}
      regionShow: {},       // 地区弹层显隐 {field_name: bool}
      regionOptions: {},    // 地区树 {field_name: [cascader options]}
      radioText: {},        // 单选(下拉)显示文本 {field_name: label}
      radioShow: {},        // 单选(下拉)弹层显隐 {field_name: bool}
    }
  },
  computed: {},
  watch: {},
  created () {
    this.platform = this.$route.query.platform;
    this.learnid = this.$route.query.learnid;
    this.token = this.$store.state.token;
    this.accountId = this.$store.state.accountId;
    this.uniqueId = this.$store.state.uniqueId;      
    this.accessid = this.$store.state.accessid;
    this.openid = this.$store.state.openid;
    this.actInfo = this.$store.state.actInfo;
    this.shareImg = this.$store.state.actInfo.share_img;
    this.shareTitle = this.$store.state.actInfo.share_title;
    this.shareDesc = this.$store.state.actInfo.share_desc;
    this.style = this.$store.state.actInfo.style;
  },
  mounted() {
    this.userInfo()
    wxShare({
      title: this.shareTitle,
      desc: this.shareDesc,
      img: this.shareImg
    })
  },
  methods: {
    setAreaid(row){
      console.log('row',row);
      this.areaId = row.value;
      this.areaName = row.text;
      this.showSelect = false;
    },
    areaData(){
      // 安装使用 js-pinyin 插件，获取待处理字段的拼音
      const pinyin = require('js-pinyin');
      
      this.areaList.map(item => { item.pinyin = pinyin.getFullChars(item.text); });
      console.log('this.areaList',this.areaList);
      let provice = {};          
      this.areaList.map((item) => {         
        const Initials = item.pinyin[0].toUpperCase();      
        // 如果对象里有当前字母项则直接 push 一个对象,如果没有则创建一个新的键并赋值;     
        if (provice[Initials]) {     
          provice[Initials].push(item);       
        } else {     
          provice[Initials] = [item];      
        }       
      });

      // 将数据转为数组，并按字母顺利排列
      this.filterData = [];  
      for(let key in provice) {
        const obj = { letter: key, list:provice[key] };
        console.log('obj',obj);
        this.filterData.push(obj)
      }    
      this.filterData.sort((a,b) => { return a.letter.localeCompare(b.letter) });
      // 为索引字符数组赋值
      this.indexList = [];
      this.filterData.forEach(item => this.indexList.push(item.letter));
      // console.log('filterData',this.filterData)
    }, 
    async getArea() {

      let result = await reqArea({region_id:this.actInfo.areaid});
      this.areaList = result;
      this.options = result
      // this.areaData()
    },
    userInfo(){
      let data = {
          platform:this.platform, //来源平台：1电脑端，2微信端，3纵览客户端，4河北日报客户端，5H5端
          learnid:this.learnid
      }      
      if(this.platform == 2){               
          data.accessid = this.accessid;
          data.openid = this.openid;
      }
      if(this.platform == 3 || this.platform == 4){
          data.account_id = this.accountId;
          data.unique_id = this.uniqueId;
      }    
      
      reqUserInfo(data).then(res => {
        console.log('res',res);
        if(res.code==200) {
          this.userData = res.data;
          this.nickname = res.data.nickname;
          this.username = res.data.username;
          this.scoreComplete = res.data.score;
          if(Number(this.scoreMust)<=Number(this.scoreComplete)){
            this.getCert = true;
          }

        } else {
          this.$toast({
              icon: 'warning-o',
              message: res.msg
          });
        }
      }).catch(err => {
        this.$toast({
              icon: 'warning-o',
              message: err
          });
      }) 
    },
    regInfo(){
      this.person_name = this.userData.person_name;
      this.phone = this.userData.phone;
      this.idcard = this.userData.idcard;
      this.address = this.userData.address;
      this.company = this.userData.company;
      this.areaid = this.userData.areaid;
      this.area_name = this.userData.area_name;
    },
    // 加载自定义登记表单字段定义（来自 info 接口 form_fields）
    loadFormFields() {
      if (this.formFields.length > 0) {
        this.initFormData();
        return;
      }
      reqLearnInfo({platform:this.platform, learnid:this.learnid}).then(res => {
        if (res.code == 200) {
          this.formFields = res.data.form_fields || [];
          this.initFormData();
        }
      }).catch(() => {})
    },
    // 初始化表单值（默认值 + 已提交值回显），并预载地区树
    initFormData() {
      const existing = this.userData.form_data || {};
      const fd = {};
      const rt = {};
      const rs = {};
      const rtt = {};
      const rsh = {};
      this.formFields.forEach(f => {
        let def = '';
        if (f.type === 'checkbox') {
          let arr = [];
          try {
            const d = JSON.parse(f.default_value);
            arr = Array.isArray(d) ? d : (d ? [d] : []);
          } catch (e) {
            arr = f.default_value ? [f.default_value] : [];
          }
          def = arr;
        } else {
          def = f.default_value || '';
        }
        // 已提交值优先
        let val = existing[f.model] !== undefined ? existing[f.model] : def;
        // checkbox 已提交值可能是 JSON 字符串
        if (f.type === 'checkbox' && typeof val === 'string') {
          try {
            const d = JSON.parse(val);
            val = Array.isArray(d) ? d : (val ? [val] : []);
          } catch (e) {
            val = val ? [val] : [];
          }
        }
        fd[f.model] = val;
        rt[f.model] = f.type === 'region' ? (this.userData.area_name || '') : '';
        rs[f.model] = false;
        if (f.type === 'region') {
          this.getRegionOptions(f);
        }
        if (f.type === 'radio' && (f.display_type === 'select' || f.display_type === 'index')) {
          rtt[f.model] = this.optionLabel(f, val);
          rsh[f.model] = false;
        }
      });
      this.formData = fd;
      this.regionText = rt;
      this.regionShow = rs;
      this.radioText = rtt;
      this.radioShow = rsh;
    },
    // 根据选项 value 取 label
    optionLabel(f, val) {
      const opt = (f.options || []).find(o => String(o.value) === String(val));
      return opt ? opt.label : '';
    },
    // 根据当前值取选项下标（用于下拉框默认定位）
    optionIndex(f) {
      const idx = (f.options || []).findIndex(o => String(o.value) === String(this.formData[f.model]));
      return idx >= 0 ? idx : 0;
    },
    // 下拉框选择完成
    onRadioConfirm(f, idx) {
      this.radioShow[f.model] = false;
      const opt = (f.options || [])[idx];
      if (opt) {
        this.$set(this.formData, f.model, opt.value);
        this.$set(this.radioText, f.model, opt.label);
      }
    },
    // 单选"首字母索引"分组数据（按选项名称首字母，类似通讯录）
    radioIndexData(f) {
      const pinyin = require('js-pinyin');
      const groups = {};
      (f.options || []).forEach(opt => {
        const label = opt.label || '';
        if (!label) return;
        let letter = '#';
        const ch = label.charAt(0);
        if (/[a-zA-Z]/.test(ch)) {
          letter = ch.toUpperCase();
        } else if (/[\u4e00-\u9fa5]/.test(ch)) {
          const py = pinyin.getFullChars(ch) || '';
          letter = py ? py.charAt(0).toUpperCase() : '#';
        }
        if (!groups[letter]) groups[letter] = [];
        groups[letter].push(opt);
      });
      const filterData = Object.keys(groups).sort((a, b) => {
        if (a === '#') return 1;
        if (b === '#') return -1;
        return a.localeCompare(b);
      }).map(letter => ({ letter, list: groups[letter] }));
      return { filterData, indexList: filterData.map(g => g.letter) };
    },
    // 首字母索引选中
    onRadioIndexSelect(f, opt) {
      this.radioShow[f.model] = false;
      this.$set(this.formData, f.model, opt.value);
      this.$set(this.radioText, f.model, opt.label);
    },
    // 获取地区联动菜单数据
    getRegionOptions(f) {
      if (this.regionOptions[f.model] && this.regionOptions[f.model].length > 0) {
        return;
      }
      const params = { platform: this.platform, learnid: this.learnid };
      if (f.region_id) {
        params.region_id = f.region_id;
      }
      reqRegion(params).then(res => {
        if (res.code == 200) {
          this.$set(this.regionOptions, f.model, res.data || []);
        }
      }).catch(() => {})
    },
    // 地区选择完成
    onRegionFinish(f, { selectedOptions }) {
      this.regionShow[f.model] = false;
      const names = (selectedOptions || []).map(o => o.text).join('/');
      this.$set(this.regionText, f.model, names);
      if (selectedOptions && selectedOptions.length > 0) {
        this.$set(this.formData, f.model, selectedOptions[selectedOptions.length - 1].value);
      }
    },
    // 客户端校验自定义表单必填项
    validateFormData() {
      for (let i = 0; i < this.formFields.length; i++) {
        const f = this.formFields[i];
        if (!f.required) continue;
        const v = this.formData[f.model];
        const empty = v === undefined || v === null || v === '' || (Array.isArray(v) && v.length === 0);
        if (empty) {
          this.$toast({ icon: 'warning-o', message: f.label + '为必填项' });
          return false;
        }
      }
      return true;
    },
    onSubmit(values) { //表单提交
     // 自定义表单客户端校验
     if (this.formFields.length > 0 && !this.validateFormData()) {
       return;
     }
     let data = {
          platform:this.platform, //来源平台：1电脑端，2微信端，3纵览客户端，4河北日报客户端，5H5端
          learnid:this.learnid, 
      }      
      if(this.platform == 2){               
          data.accessid = this.accessid;
          data.openid = this.openid;
      }
      if(this.platform == 3 || this.platform == 4){
          data.account_id = this.accountId;
          data.unique_id = this.uniqueId;
      }  
      // 自定义登记表单数据
      if (this.formFields.length > 0) {
        data.form_data = JSON.stringify(this.formData);
      }
      console.log('values',values);
      console.log('data',data);

      reqUserEdit({...values,...data}).then(res => {
        console.log('res',res);
        if(res.code==200) {
          this.showEdit = false;
          this.$toast({
              icon: 'success',
              message: res.msg
          });
        } else {
          this.$toast({
              icon: 'warning-o',
              message: res.msg
          });
        }
      }).catch(err => {
        this.$toast({
              icon: 'warning-o',
              message: err
          });
      }) 

    },
    // 全部选项选择完毕后，会触发 finish 事件
    onFinish({ selectedOptions }) {
      this.showSelect = false;
      console.log(selectedOptions);
      this.areaName = selectedOptions.map((option) => option.text).join('/');
      if(selectedOptions.length>0){
        this.areaId = selectedOptions[selectedOptions.length-1].value;
      }else{
        this.areaId = selectedOptions[0].value;
      }      
    },
    login(){
      this.$refs.child.toLink()
    },
    logOut(){
      localStorage.clear(); //清空本地观看记录
      Cookies.set('ckplayer-player-cookie','');
      this.$router.push({ path: '/index',query:this.$route.query })  //返回首页
    },
    editBox(){
      this.showEdit = true;
      this.regInfo();
      this.loadFormFields();
      if(this.actInfo.areaid>0) {
        this.getArea();
      }
      
    },
    noticeBox(){
      let data = {
          platform:this.platform, //来源平台：1电脑端，2微信端，3纵览客户端，4河北日报客户端，5H5端
          learnid:this.learnid, 
      }  

      this.loading = true
      reqLearnExtend(data).then(res => {
        this.loading = false
        if(res.code==200) {
          this.actExtend = res.data;        
          
        } else {
          this.$toast({
              icon: 'warning-o',
              message: res.msg
          });
        }        
        
      }).catch(() => {
        this.loading = false
      }) 
      this.showNotice = true;
    },
    async kefuBox(){
      let data = {
          platform:this.platform, //来源平台：1电脑端，2微信端，3纵览客户端，4河北日报客户端，5H5端
          learnid:this.learnid, 
          lessionid:this.lessionid
      }      
      if(this.platform == 2){               
          data.accessid = this.accessid;
          data.openid = this.openid;
      }
      if(this.platform == 3 || this.platform == 4){
          data.account_id = this.accountId;
          data.unique_id = this.uniqueId;
      }  
      let result = await reqExplain(data);
      if(result.flag=='success') {
        this.kefu = result.data.kefu; 
      }
      this.showKefu = true;
    },
    zhengshuBox(){
      this.$toast({
          icon: 'warning-o',
          message: "暂无证书"
      });
      // if(this.getCert){
      //     this.showZhengshu = true;
      //     let _this = this;
      //     setTimeout(function(){
      //       _this.toImage();
      //     },500)  
      // } else {
      //   this.$toast({
      //     icon: 'warning-o',
      //     message: "尚未获得证书"
      //   });
      // }
          
    },    
    toImage(){
		  let domObj = document.getElementById("posterMiddle");
		  //获取到DOM节点的位置
          let width = domObj.offsetWidth;
          let height = domObj.offsetHeight;
          //DOM元素的宽高
          let canvas = document.createElement("canvas")
          //创建canvas
          let scale = 5
          //放大比例设置5倍
          canvas.width = width * scale
          canvas.height = height * scale
          //画板的宽高
          let options = {
              logging: true,
              //日志开关，在控制台可以查看html2canvas的内部执行流程
              width: width,
              height: height,
              //避免下载不全
              useCORS: true,
              //【重要】开启跨域配置
              scale: scale, 
              canvas: canvas,
              //自定义属性
          }
          html2canvas(domObj, options).then((canvas) => {
              let context = canvas.getContext('2d') 
              //关闭锯齿
              context.mozImageSmoothingEnabled = false
              context.webkitImageSmoothingEnabled = false
              context.msImageSmoothingEnabled = false
              context.imageSmoothingEnabled = false
              let img = Canvas2Image.convertToJPEG(canvas, canvas.width, canvas.height)
              // 这就是把canvas转化为图片
              document.getElementById('Image').innerHTML = "";
              document.getElementById('Image').appendChild(img);
              //展示图片的DOM节点
              img.style.width = canvas.width/5 + 'px';
              img.style.height = canvas.height/5 + 'px';
          })          
          this.showLoad = false;
		},
  },
}
</script>
<style lang="scss" scoped>
.page{
  width: 750px;
  min-height: 1366px;
  font-size: 30px;
  background-repeat: no-repeat;
  background-size: contain;
  .mainBox{
    width: 700px;
    min-height:1200px;    
    position: absolute;
    left: 50%; transform: translateX(-50%);
    top: 150px;    
    background: #fff;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    padding-top: 80px;
    .avatar{
      width: 100%;
      height: 140px;
      display: flex;
      justify-content: center;
      img{
        width: 140px;
        height: 140px;
      }
    }
    .username{
      width: 100%;
      height: auto;
      line-height:50px;
      margin-top: 30px;
      text-align: center;
      font-size: 36px;
      font-weight: bold;
      margin-bottom: 50px;
    }
    .boxline{ width: 74%; height: 2px; background: #dcdcdc; margin: 0 auto;}
    .userData{
      width: 100%;
      height: auto;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 15px;
      margin-bottom: 15px;
      .total,.must,.done{
        padding: 0px 40px;  
        color:#919191;
        .txt{
          display: block;
          width: 100%;
          height: 50px;
          line-height: 50px;
          text-align: center;
          padding:10px 0px;
        }
        .num{
          display: block;
          width: 100%;
          height: 50px;
          line-height: 50px;
          text-align: center;
          font-size: 40px;
          font-weight: bold;
          padding:10px 0px;
        }
      }
      .total{
        .num{ color:#b5b5b5;}
      }
      .must{
        .num{ color:#f9695d;}
      }

      .done{
        .num{ color:#81a3e5;}
      }
      .line{
        width: 2px;
        height: 100px;
        background: #dcdcdc;
      }

    }

    .optBox{
      width: 620px;
      height: auto;
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-items: center;
      margin-top: 30px;
      padding: 10px 40px;
      .icoBox{
        width: 205px;
        height: auto;
        margin-bottom: 30px;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        text-align: center;
        .icon{
          width: 95px;
          height: 95px;
          border-radius: 25px;
          background: #fbf4da;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 25px;
          i{
            font-size: 44px;
            color: #fff;
          }          
        }
        .icon1{ 
          background: #8CD34B;
        }
        .icon2{ 
          background: #436ECD;
        }
        .icon3{ 
          background: #81D694;
        }
        .icon4{ 
          background: #FA9B31;
        }
        .icon5{ 
          background: red;
        }
        span{
          display: block;
          width: 100%;
          font-size: 26px;
          line-height: 30px;
          color: #828282;
        }
      }
    }    
  }
  .showBox{
    background: none;
  }

  .zhengshu{
    width: 650px;
    height: 980px;
    margin: 0px 50px;
    margin-top:100px;
    position: relative;
    .zsBox{
      width: 100%;
      height: auto;
      position: absolute;
      left: -100vw;
      top:0;
      z-index: 9;
      .zsBg{
        width: 100%;
        height: auto;
      }
      .zsTxt{ 
        position: absolute;
        left: 150px;
        top: 290px;
        color: #000;
        font-size: 26px;
        font-family: "宋体";
        font-weight: bold;
        z-index: 99;
      }
    }
    .loadBox{
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      left: 0;
      top: 0;
      z-index: 100;
    }
    .downBox{
      width: 100%;
      height: auto;
      position: relative;
      left: 0;
      top: 0;
      z-index: 99;
      .imgBox{
        width: 100%;
        height: auto;
      }
      .downTxt{
        width: 100%;
        height: 30px;
        line-height: 30px;
        margin-top:30px;
        font-size: 30px;
        color:#fff;
        text-align: center;
        i{
          font-size: 30px;
        }
      }
    }
    
  }

  .noticBox{ width: 100%; height: auto; font-size: 30px; padding-bottom: 80px; overflow: hidden;}
  .noticTitle{ display: block; width: 100%; height: 30px; margin-top: 80px; font-size: 34px; display: flex; align-items: center; justify-content: center;}
  .noticTxt{ width: 670; height: auto;  padding:0px 40px; margin-bottom: 30px; overflow: hidden; overflow-y: auto;}
  .noticTxt p{ padding: 0; margin: 15px 0px; width: 100%; text-indent: 2em; text-align: justify;}
  .noticBox .text{ padding: 0px 30px; color:var(--styleColor);}
  .noticBox .line{ border-top: 1px solid var(--styleColor); width: 130px; }
  
  .editBox{ 
    width: 670; 
    height: auto;  
    padding:0px 40px; 
    margin-bottom: 30px; 
    overflow: hidden; 
    overflow-y: auto;
    .van-popup{ z-index: 9999;}
    .subBtn{ margin:0px; margin-top:50px;}
    .van-button{ background: var(--styleColor); border: 0px; border-radius: 15px;}
    .huodong{ padding-right: 15px; margin-right:20px; border-right: 2px solid #e7e8e8;}
    .van-cell{ border:2px solid #e7e8e8; padding:12px 15px; margin-bottom: 30px; border-radius: 10px;}
    .van-cell::after{ border:0px;}
  }
  .areaBox{
    .van-cell{ border:0px; margin:0px 15px; margin-bottom: 10px; border-radius: 0px;}
    .van-index-anchor{ font-weight: bold;}
    ::v-deep .van-index-bar__index{
      padding: 10px 20px;
      font-size: 26px;
    }
  }
}
</style>
